import React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTelegram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import FooterCol from "./FooterCol";
import "./Footer.css";
import { usefulLink, ourServices, otherLinks, footerInfo } from "./FooterData";
import { Link } from "react-router-dom";
//import { scrollUP } from '../../Shared/ScrollTop/ScrollTop';

const Footer = () => {
  return (
    <section className="row footer">
      <Row className="col-md-11 mx-auto">
        <Col md={6} lg={3} className="fAboutUs">
          <h5>ABOUT US</h5>
          <span className="animate-border"></span>
          <p className="aboutUsDes">
            Guiding Your Wealth Journey: The Compass of Expertise in Financial
            Wisdom, Leading You Towards Informed Decisions and Flourishing
            Finances.
          </p>
          <ul className="socialIcons">
            <li>
              <Link to={"https://www.facebook.com/financeBdariija/"}>
                <FontAwesomeIcon icon={faFacebook} />
              </Link>
            </li>
            <li>
              <Link to={"https://www.instagram.com/_financebdarija_/"}>
                <FontAwesomeIcon icon={faInstagram} />
              </Link>
            </li>
            <li>
              <Link to={"https://www.youtube.com/@Financebdarija"}>
                <FontAwesomeIcon icon={faYoutube} />
              </Link>
            </li>
            <li>
              <Link to={"https://t.me/Moroccan_Financial_show"}>
                <FontAwesomeIcon icon={faTelegram} />
              </Link>
            </li>
          </ul>
        </Col>
        <FooterCol key="2" menuItems={usefulLink} title="USEFUL LINK" />
        <FooterCol key="3" menuItems={ourServices} title="OUR SERVICES" />
        <FooterCol key="4" menuItems={otherLinks} title="OTHER LINKS" />
      </Row>
      <p className="copyRight">
        Copyright &copy; 2023{" "}
        . All rights reserved. Made by {" "}
        <a className="fHighlight" href="https://hmwebs.com/" target="_blank" rel="noreferrer">
         HMWeb
        </a>
        
      </p>
    </section>
  );
};

export default Footer;
